import { AdminPermission } from '@mol-limo-reg/admin-api';
import { AdminPermissionVM } from './add-amin-dialog.vm';

export const mapAdminPermissionsVmToApiModel: Record<
  AdminPermissionVM,
  AdminPermission
> = {
  [AdminPermissionVM.AdminManagement]: AdminPermission.ADMIN_MANAGEMENT,
  [AdminPermissionVM.BlackListManagement]: AdminPermission.BLACKLIST_MANAGEMENT,
  [AdminPermissionVM.ClaimManagement]: AdminPermission.CLAIMS_MANAGEMENT,
  [AdminPermissionVM.RentalManagement]: AdminPermission.RENTAL_MANAGEMENT,
  [AdminPermissionVM.CarManagement]: AdminPermission.CAR_MANAGEMENT,
  [AdminPermissionVM.CopyManagement]: AdminPermission.COPY_MANAGEMENT,
  [AdminPermissionVM.StationManagement]: AdminPermission.STATION_MANAGEMENT,
};

export const mapAdminPermissionsApiModelToVm: Record<
  AdminPermission,
  AdminPermissionVM
> = {
  [AdminPermission.ADMIN_MANAGEMENT]: AdminPermissionVM.AdminManagement,
  [AdminPermission.BLACKLIST_MANAGEMENT]: AdminPermissionVM.BlackListManagement,
  [AdminPermission.CLAIMS_MANAGEMENT]: AdminPermissionVM.ClaimManagement,
  [AdminPermission.RENTAL_MANAGEMENT]: AdminPermissionVM.RentalManagement,
  [AdminPermission.CAR_MANAGEMENT]: AdminPermissionVM.CarManagement,
  [AdminPermission.COPY_MANAGEMENT]: AdminPermissionVM.CopyManagement,
  [AdminPermission.STATION_MANAGEMENT]: AdminPermissionVM.StationManagement,
};
